import React from 'react';
import { fetchAllLeads } from '../../actions/fetchAllLeads';
import { fetchMappingZunpulse, fetchAllMapping, fetchMappingZunsolar } from '../../actions/fetchAllMapping';
import { getSearchResult } from '../../actions/searchAction';
import { editBulkLeads } from '../../actions/editMultipleLeadsAction'
import { getUserInfo } from '../../actions/user'
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { render } from '@testing-library/react';
import Header from '../../components/HeaderComponent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorComponent } from '../../components/ErrorComponent';
import { Loader } from '../../components/loader'
import AllOfflineDealerLeadsView from '../../components/zunsolar/AllOfflineDealerLeadsView';

class AllOfflineDealerLeads extends Component {
  componentWillMount() {
    let filterObj = {leadType:["Retailer","Distributor"]}
    let viewList = ["employees"]
    this.props.fetchAllMapping(viewList);
    this.props.fetchAllLeads(100, 1, [],filterObj, 'zunsolar');
    this.props.fetchMappingZunsolar();

    // this.props.getSearchResult()
  }

  render() {
    if (this.props.error) {
      return (
        <div>
          <ErrorComponent error={this.props.error} />
        </div>
      )
    }

    return (
      <div>
        <Header/>
        <AllOfflineDealerLeadsView allLeads={this.props.allLeads} allMapping={this.props.allMapping} fetchAllLeads={this.props.fetchAllLeads} searchData={this.props.searchData} editBulkLeads={this.props.editBulkLeads} />
      </div>
    )


  }
}


function mapStateToProps(state) {
  // console.log("searchData", state)

  return {
    allLeads: state.allFetchLead ? state.allFetchLead : {},
    allMapping: state.fetchAllMapping ? state.fetchAllMapping : {},
    searchData: [],
    error: state.allFetchLead.error ? state.allFetchLead.error : undefined

  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ editBulkLeads, fetchAllLeads, fetchAllMapping, fetchMappingZunpulse, getSearchResult, getUserInfo, fetchMappingZunsolar }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AllOfflineDealerLeads);